// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "de-DE-json" + "." + "fde96dfab194997fc682" + ".js";
};